import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['Llamadas de estudios jurídicos amenazando con embargo de sueldo — sin saber si pueden hacerlo', 'Registros negativos que quizás ya deberían haber desaparecido hace años — pero nadie te lo dijo', 'Siempre la misma angustia porque no tenés un protocolo claro de respuesta y defensa', 'El Derecho al Olvido, los plazos de prescripción, el mínimo inembargable — sin sistema para aplicarlos', 'Deudas con más de 5 años de mora sin saber que ya podrían estar caducadas legalmente', 'Semana angustiante, y la próxima semana volvés a empezar el mismo ciclo sin resolver nada'];
  return <section className="py-12 md:py-20 px-4 bg-brand-dark relative overflow-hidden" data-id="element-236">
      <div className="absolute top-0 right-0 w-96 h-96 bg-red-900/10 rounded-full blur-[100px] pointer-events-none" data-id="element-237" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-238">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-239">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-6 leading-tight" data-id="element-240">
            ¿Cuántas Semanas Más Vas a Vivir Con Este Peso?
          </h2>
          <div className="space-y-4 text-cream/90 text-lg text-left md:text-center" data-id="element-241">
            <p data-id="element-242">
              Sos una persona que trabaja, que tiene responsabilidades, que
              quiere avanzar.
            </p>
            <p data-id="element-243">
              Pero hay algo que te frena. Que aparece en el momento más
              inoportuno.
            </p>
            <p data-id="element-244">
              Una llamada a las 9 de la mañana de un número desconocido. Un
              rechazo en el banco cuando más lo necesitabas. Una puerta cerrada
              cuando querías alquilar, comprar, pedir un crédito para la moto o
              para una emergencia.
            </p>
            <p className="text-xl font-bold text-white py-4" data-id="element-245">
              "Usted figura en el Clearing."
            </p>
            <p data-id="element-246">Esas cuatro palabras que duelen como una cachetada.</p>
            <p data-id="element-247">
              Quizás intentaste ignorar las llamadas. Quizás prometiste pagar
              algo "para que paren". Quizás buscaste información en internet y
              encontraste cosas genéricas que no aplican a Uruguay.
            </p>
            <p className="font-bold text-gold" data-id="element-248">Y el ciclo sigue.</p>
            <p className="font-medium" data-id="element-249">
              No es falta de voluntad. Es falta de un sistema.
            </p>
          </div>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-250">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-red-950/20 border border-red-900/30 rounded-xl p-4 flex gap-4 items-start" data-id="element-251">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-252" />
              <p className="text-cream/90 text-sm md:text-base" data-id="element-253">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-254">
          <h3 className="text-2xl md:text-3xl font-bold text-gold-gradient" data-id="element-255">
            ¿Y Si Esta Fuera la Última Semana que Vivís Así?
          </h3>
        </motion.div>
      </div>
    </section>;
}